import React, { useEffect, useState } from 'react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  Stack,
  TextField,
  Button,
  MenuItem,
  Chip,
  Divider,
  Box,
  Alert
} from '@mui/material';

import {
  Save,
  Edit,
  ArrowBack
} from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';

import praticaApi from '../../api/praticaApi';
import annoFiscaleApi from '../../api/annoFiscaleApi';

const statiPratica = [
  'APERTA',
  'IN_ATTESA_DOCUMENTI',
  'COMPLETATA',
  'CHIUSA'
];

const prioritaList = [
  'BASSA',
  'MEDIA',
  'ALTA',
  'URGENTE'
];

export default function PraticaEditPageDesktop() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [success, setSuccess] = useState(false);
  const [annoFiscale, setAnnoFiscale] = useState({});
  const [pratica, setPratica] = useState({
    nome: '',
    descrizione: '',
    tipo: '',
    stato: 'APERTO',
    priorita: 'MEDIA',
    assegnatario: '',
    noteInterne: '',
    annoFiscaleId: null,
    contribuenteId: null
  });

  useEffect(() => {
    fetchPratica();
  }, [id]);
  useEffect(() => {
    fetchAnnoFiscale(pratica.annoFiscaleId);
  }, [id]);
  const fetchPratica = async () => {

    try {

      const res = await praticaApi.getById(id);
      console.log("pratica ",res.data);
      setPratica(res.data);

    } catch (err) {

      console.error(err);

    }
  };
  const fetchAnnoFiscale = async (idAnnoFiscale) => {
    try {
      const res = await annoFiscaleApi.getById(idAnnoFiscale);
      console.log("annoFiscale fiscale",res.data);
      setAnnoFiscale(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const handleChange = (field, value) => {

    setPratica(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {

    try {

      setLoading(true);

      await praticaApi.update(id, pratica);

      setSuccess(true);

      setTimeout(() => {
        setSuccess(false);
      }, 3000);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  const getStatoColor = (stato) => {
    switch (stato) {
      case 'APERTA':
        return 'info';

      case 'IN_ATTESA_DOCUMENTI':
        return 'warning';

      case 'COMPLETATA':
        return 'success';

      case 'CHIUSA':
        return 'error';

      default:
        return 'default';
    }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 3 }}
    >

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
        >

          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
          >
            Indietro
          </Button>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Modifica Pratica
          </Typography>

        </Stack>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
        >

          <Chip
            label={pratica.stato}
            color={getStatoColor(pratica.stato)}
          />

          <Button
            variant="outlined"
            startIcon={<Edit />}
          >
            Cambia Stato
          </Button>

        </Stack>

      </Stack>

      {success && (
        <Alert
          severity="success"
          sx={{ mb: 3 }}
        >
          Pratica salvata correttamente
        </Alert>
      )}

      <Card
        sx={{
          borderRadius: 3
        }}
      >

        <CardContent>

          <Typography
            variant="h6"
            sx={{ mb: 3 }}
          >
            Informazioni pratica
          </Typography>

          <Stack spacing={3}>

          <Typography
            variant="h6"
            sx={{ mb: 3 }}
          >
            Anno fiscale: {annoFiscale.anno}
          </Typography>
            <TextField
              fullWidth
              label="Nome pratica"
              value={pratica.nome || ''}
              onChange={(e) =>
                handleChange('nome', e.target.value)
              }
            />

            <TextField
              fullWidth
              multiline
              rows={4}
              label="Descrizione"
              value={pratica.descrizione || ''}
              onChange={(e) =>
                handleChange('descrizione', e.target.value)
              }
            />

            <Divider />

            <Stack
              direction={{
                xs: 'column',
                md: 'row'
              }}
              spacing={2}
            >

              <TextField
                fullWidth
                select
                label="Stato"
                value={pratica.stato || ''}
                onChange={(e) =>
                  handleChange('stato', e.target.value)
                }
              >
                {statiPratica.map((s) => (
                  <MenuItem
                    key={s}
                    value={s}
                  >
                    {s}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                select
                label="Priorità"
                value={pratica.priorita || ''}
                onChange={(e) =>
                  handleChange('priorita', e.target.value)
                }
              >
                {prioritaList.map((p) => (
                  <MenuItem
                    key={p}
                    value={p}
                  >
                    {p}
                  </MenuItem>
                ))}
              </TextField>

            </Stack>

            <TextField
              fullWidth
              label="Assegnatario"
              value={pratica.assegnatario || ''}
              onChange={(e) =>
                handleChange('assegnatario', e.target.value)
              }
            />

            <Divider />

            <TextField
              fullWidth
              multiline
              rows={5}
              label="Note interne"
              value={pratica.noteInterne || ''}
              onChange={(e) =>
                handleChange('noteInterne', e.target.value)
              }
            />

            <Box>

              <Button
                variant="contained"
                startIcon={<Save />}
                onClick={handleSave}
                disabled={loading}
              >
                Salva Modifiche
              </Button>

            </Box>

          </Stack>

        </CardContent>

      </Card>

    </Container>
  );
}
